/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListTriggerDefinitionsSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListTriggerDefinitionsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListTriggerDefinitionsSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListTriggerDefinitionsSecurity$outboundSchema: z.ZodMiniType<
  ListTriggerDefinitionsSecurity$Outbound,
  ListTriggerDefinitionsSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listTriggerDefinitionsSecurityToJSON(
  listTriggerDefinitionsSecurity: ListTriggerDefinitionsSecurity,
): string {
  return JSON.stringify(
    ListTriggerDefinitionsSecurity$outboundSchema.parse(
      listTriggerDefinitionsSecurity,
    ),
  );
}

/** @internal */
export type ListTriggerDefinitionsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListTriggerDefinitionsRequest$outboundSchema: z.ZodMiniType<
  ListTriggerDefinitionsRequest$Outbound,
  ListTriggerDefinitionsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listTriggerDefinitionsRequestToJSON(
  listTriggerDefinitionsRequest: ListTriggerDefinitionsRequest,
): string {
  return JSON.stringify(
    ListTriggerDefinitionsRequest$outboundSchema.parse(
      listTriggerDefinitionsRequest,
    ),
  );
}
